<div class="app-header-band">
  <div class="govuk-width-container">
    <div class="d-flex">
        <gb-ui-header
            [imageDetail]="imageDetail"
            [showSearch]="false"
            [navLinks]="navigation"
          >
        </gb-ui-header>
    </div>
  </div>
</div>
